<app-page-title title="Célula"></app-page-title>
<div class="group-info">
  <h3><label>Nome: &nbsp;</label>{{ group?.name }}</h3>
  <h3><label>Setor: &nbsp;</label>{{ group?.sector?.name }}</h3>
</div>

<div class="group">
  <h1 class="membros-title" *ngIf="group?.members">Membros</h1>
  <cdk-virtual-scroll-viewport itemSize="10" class="example-viewport" orientation="vertical">
    <div *cdkVirtualFor="let member of group?.members" class="example-item">
      <div class="photo">
        <img [src]="getAvatar(member.avatar)" />
      </div>
      <div class="details">
        <p>{{ member.name }}</p>
        <p class="function">
          {{ group.leader_id === member.id ? '* Líder *' : member?.groupFunction?.name }}
        </p>
        <div class="action-buttons">
          <button>
            <img
              src="../../../assets/icons/visibility_black_24dp.svg"
              matTooltip="Vizualizar"
              [routerLink]="['/membro/vizualizar/' + member.id]"
            />
          </button>
          <button class="btn-edit">
            <img src="../../../assets/icons/edit.svg" matTooltip="Editar" [routerLink]="['/membro/' + member.id]" />
          </button>
        </div>
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
